import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import styles from '../../PackagesRoomsAmenities.module.scss';

import type { EntitySectionConfig } from './entity';

type RenderSection<T> = (section: EntitySectionConfig<T>) => React.ReactNode;

type Props<T> = {
  title: string;
  createLabel: string;
  sections: EntitySectionConfig<T>[];
  renderSection: RenderSection<T>;
  onCreate: () => void;
};

export const EntityTable = <T,>({
  title,
  createLabel,
  sections,
  renderSection,
  onCreate,
}: Props<T>) => (
  <div className={styles.card}>
    <div className={styles.headerRow}>
      <div className={styles.headerTitle}>{title}</div>
      <Button icon={<PlusOutlined />} onClick={onCreate}>
        {createLabel}
      </Button>
    </div>

    {sections.map(renderSection)}
  </div>
);
